/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import RemoveActions from "../GroupReservations/Components/RemoveActions";
import WaitlistActions from "../GroupReservations/Components/WaitlistActions";
import ReservationsEmpty from './ReservationsEmpty'
import SearchGroupComponent from "../GroupReservations/Components/SearchGroupComponent"

import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { Link, useParams } from 'react-router-dom';
import { vaccineGroupService } from '../../../_services/vaccine-group.service';

export default function AllReservations(props) {
  const columns = [
    {
      name: 'Status',
      sort: false,
      grow: 1,
      cell: row => {
        if (row.status === 'waitlist') {
          return <span className="badge bg-primary text-white">WAITLIST</span>
        } else if (row.status === 'pending') {
          return <span className="badge bg-info text-white">PENDING</span>
        } else if (row.status === 'scheduled') {
          return <span className="badge bg-success text-white">SCHEDULED</span>
        } else if (row.status === 'removed') {
          return <span className="badge bg-danger text-white">REMOVED</span>
        } else if (row.status === 'rejected') {
          return <span className="badge bg-warning">REJECTED</span>
        }
      }
    },
    {
      name: 'Name',
      sort: false,
      grow: 2,
      cell: reservation => `${reservation.firstName} ${reservation.lastName}`
    },
    {
      name: 'Date of Birth',
      sort: false,
      selector: 'dateOfBirth',
      grow: 2
    },
    {
      name: 'Phone Number',
      sort: false,
      selector: 'phoneNumber',
      grow: 2
    },
    {
      name: 'Allow SMS',
      sort: false,
      cell: reservation => reservation.allowSms ? <span className="badge bg-success text-white">YES</span> : <span className="badge bg-warning">NO</span>,
      grow: 1
    },
    {
      name: 'Group',
      sort: false,
      cell: reservation => reservation.group.name,
      grow: 2
    },
    {
      name: 'Reserved At',
      sort: false,
      cell: reservation => moment.tz(reservation.createdAt.date, reservation.createdAt.timezone).local().format('l LT'),
      grow: 2
    },
    {
      button: true,
      sort: false,
      width: '200px',
      cell: row => {
        if (row.status === 'waitlist') return <WaitlistActions data={row} reload={() => retrieve()} />
        if (row.status === 'removed') return <RemoveActions data={row} reload={() => retrieve()} />
      }
    }
  ];

  const DetailComponent = ({ data }) => {
    return <div className="row">
      <div className="col-lg-4">
        <ul className="list-group list-group-flush">
          <li className="list-group-item"><strong>ID:</strong> {data.reservationId}</li>
        </ul>
        <ul className="list-group list-group-flush">
          <li className="list-group-item"><strong>Reserved At:</strong> {moment.tz(data.createdAt.date, data.createdAt.timezone).local().format('l LT')}</li>
        </ul>
      </div>
    </div>
  }

  const { groupId } = useParams();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [initLoad, setInitLoad] = useState(true);
  const [groupName, setGroupName] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [reservations, setReservations] = useState([]);

  function retrieve(params = null) {
    vaccineGroupService.reservations(params)
      .then(data => {
        setLoading(false);
        setInitLoad(false)
        setTotalRows(data.total);
        setGroupName(data.groupName);
        setReservations(data.collection.data);
      })
      .catch(() => {
        setLoading(false);

        dispatch(alertActions.error('Could not load reservations. Please try again.'));
      });
  }

  function dateToYYYYMMDD(dob) {
    return dob ? dob.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2") : '';
  }

  useEffect(() => {
    retrieve();
  }, []);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active" aria-current="page">All Reservations</li>
      </ol>
    </nav>

    {initLoad && loading ?
      <Spinner animation="border" role="status" />
      :
      initLoad && reservations.length === 0 ?
        <ReservationsEmpty />
        :
        <DataTable
          title={groupName}
          columns={columns}
          data={reservations}
          overflowY={true}
          progressPending={loading}
          onChangePage={page => {
            setLoading(true);
            let queryParams = queryString.parse(props.location.search);
            queryParams.page = page;
            props.history.replace(`?${queryString.stringify(queryParams)}`);
            queryParams.dateOfBirth = dateToYYYYMMDD(queryParams.dateOfBirth);
            retrieve(queryParams);
          }}
          subHeader={true}
          subHeaderComponent={
            <SearchGroupComponent
              location={props.location}
              handleClear={() => { retrieve() }}
              handleSearch={(params) => {
                const { status, firstName, lastName, dateOfBirth } = params;
                props.history.replace(`?status=${status}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`);
                params.dateOfBirth = dateToYYYYMMDD(params.dateOfBirth);

                if (props.history.location.search !== props.location.search) {
                  retrieve(params);
                }
              }} />
          }
          striped={true}
          pagination={true}
          paginationServer={true}
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={15}
          expandableRows
          expandOnRowClicked
          expandableRowsComponent={<DetailComponent />}
          noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
          customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
        />
    }
  </div>
}